import  html2pdf  from 'html2pdf.js'
import moment from 'moment'
import React, { memo, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Divider, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { useStyle } from './style'
import { useNavigate } from 'react-router-dom'
import _ from 'lodash'
import axios from 'axios'
import { resetData } from '../../hooks/printPdf/pdfData'

const ProductPdf = () => {
    const classes = useStyle()
    const navigate = useNavigate()
    const dispatch = useDispatch()
const data = useSelector(state=> state.getData)
const ref = useRef(null)
console.log(data)

const totalCgstAmnt = data.getData!==null && data.getData.tableData.reduce((acc, value) => acc + Number(value.cgstAmnt), 0);
    const rowTotals = data.getData!==null && data.getData.tableData.map((value) => Number(value.cgstAmnt) + Number(value.cgstAmnt));
    const totalNetAmnt = data.getData!==null && data.getData.tableData.reduce((acc, rowTotal) => acc + rowTotal.totalAmt, 0);

useEffect(()=>{
if(data.getData!==null && data.getData.tableData.length > 0){   
    const input = ref.current;
    const pdfOptions = {
      margin: 10,
      filename: `billNo_${data.getData.docNo}_${moment().format("YYYY-MM-DD")}`, // Include the date in the filename
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      pagebreak: { mode: 'avoid-all' },
      jsPDF: { unit: "mm", format: "a4", orientation: "landscape" },
    };
    
html2pdf().set(pdfOptions).from(input).save()

  setTimeout(()=>{
    window.location.reload();
    dispatch(resetData())
    navigate(-1)
  },3000)
}
},[data])

  return (
    <div ref={ref}  className='bg-white w-full' >
   {data.getData !== null && 
    <Grid sx={{border:'2px solid black'}}>
    <Typography fontWeight={600} variant='h5' textAlign='center' sx={{backgroundColor:'rgb(203 213 225)', borderBottom:'1px solid', width:'100%', paddingBlock:1}}>{data.getData.title}</Typography>
     
    <TableContainer className={classes.tblRoot}>
     <Table>
         <TableHead className={classes.tblHead}>
             <TableRow >
                 <TableCell rowSpan={2} >Sl No</TableCell>
                 <TableCell rowSpan={2}>Description of Goods</TableCell>
                 <TableCell rowSpan={2}>Rate</TableCell>
                 <TableCell rowSpan={2}>Qty</TableCell>
                 <TableCell rowSpan={2}>Discount</TableCell>
                 <TableCell rowSpan={2}>Taxable Value</TableCell>
                 <TableCell colSpan={2}>CGST</TableCell>
                 <TableCell colSpan={2}>SGST</TableCell>
                 <TableCell rowSpan={2} >Amount</TableCell>
             </TableRow>
             <TableRow >
                 <TableCell>%</TableCell>
                 <TableCell>Amt</TableCell>
                 <TableCell>%</TableCell>
                 <TableCell>Amt</TableCell>
             </TableRow>
         </TableHead>
         <TableBody>
            {_.map(data.getData.tableData , (val,idx) => (
                <TableRow className={classes.tblRow} key={idx}>
                    <TableCell>{idx + 1}</TableCell>
                    <TableCell>{val.pro_name}</TableCell>
                    <TableCell>{val.sale_rate}</TableCell> 
                    <TableCell>{val.qty}</TableCell> 
                    <TableCell>{val.disc1}</TableCell>
                    <TableCell>{parseFloat(val.sale_rate * val.qty).toFixed(2)}</TableCell>
                    <TableCell> {parseFloat(val.cgstPerc).toFixed(2)/2}</TableCell>
                    <TableCell> {parseFloat(val.cgstAmnt).toFixed(2)/2}</TableCell>
                    <TableCell> {parseFloat(val.cgstPerc).toFixed(2)/2}</TableCell>
                    <TableCell> {parseFloat(val.cgstAmnt).toFixed(2)/2}</TableCell>
                    <TableCell>{parseFloat(val.totalAmt).toFixed(2)}</TableCell>
                </TableRow>
            ))}
         </TableBody>
     </Table>
    </TableContainer>
    <Grid className='flex justify-between p-2'>
     <TableContainer className={classes.tblRoot} sx={{maxWidth: 'fit-content'}}>
         <Table sx={{borderLeft:'1px solid'}}>
             <TableHead className={classes.tblHead}>
                 <TableRow>
                     <TableCell>Tax</TableCell>
                     <TableCell>CGST Amt</TableCell>
                     <TableCell>SGST Amt</TableCell>
                     <TableCell>Total</TableCell>
                 </TableRow>
             </TableHead>
             <TableBody>
                {_.map(data.getData.tableData , (value , idx) => (
                    <TableRow className={classes.tblRow} key={idx}>
                        <TableCell>{parseFloat(value.cgstPerc).toFixed(2)}</TableCell>
                        <TableCell>{parseFloat(value.cgstAmnt).toFixed(2)}</TableCell>
                        <TableCell>{parseFloat(value.cgstAmnt).toFixed(2)}</TableCell>
                        <TableCell>{parseFloat(Number(value.cgstAmnt) + Number(value.cgstAmnt)).toFixed(2)}</TableCell>
                    </TableRow>
                ))}
                 <TableRow className={classes.tblRow}>
                     <TableCell>Total</TableCell>
                     <TableCell >{parseFloat(totalCgstAmnt).toFixed(2)}</TableCell>
                     <TableCell>{parseFloat(totalCgstAmnt).toFixed(2)}</TableCell>
                     {/* <TableCell>{parseFloat(totalNetAmnt).toFixed(2)}</TableCell> */}
                     <TableCell>{parseFloat(totalCgstAmnt + totalCgstAmnt).toFixed(2)  }</TableCell>
                 </TableRow>
             </TableBody>
         </Table>
     </TableContainer>
     <Grid sx={{width:150, }}>
         <div className={classes.pdfFlexBetween}>
             <Typography className={classes.pdfTextTable}>Sub Total  </Typography>
             <Typography className={classes.pdfTextTable}>{parseFloat(data.getData.TotalData.sub_total).toFixed(2)}</Typography>
         </div>
         {/* <div className={classes.pdfFlexBetween}>
             <Typography className={classes.pdfTextTable}>Discount  </Typography>
             <Typography className={classes.pdfTextTable}>{parseFloat(data.getData.TotalData.gst).toFixed(2)}</Typography>
         </div> */}
         <div className={classes.pdfFlexBetween}>
             <Typography className={classes.pdfTextTable}>GST  </Typography>
             <Typography className={classes.pdfTextTable}>{parseFloat(data.getData.TotalData.gst).toFixed(2)}</Typography>
         </div>
         <div className={classes.pdfFlexBetween}>
             <Typography className={classes.pdfTextTable}>Round Off  </Typography>
             <Typography className={classes.pdfTextTable}>{parseFloat(data.getData.TotalData.roundOff).toFixed(2)}</Typography>
         </div>
         <div className={classes.pdfFlexBetween}>
             <Typography className={classes.pdfTextTable}>Total  </Typography>
             <Typography className={classes.pdfTextTable}>{parseFloat(data.getData.TotalData.totalAmount).toFixed(2)}</Typography>
         </div>
         
     </Grid>
    </Grid>
    <Divider sx={{border:"1px solid #000"}} />
    <Grid className='flex justify-between'>
         <Grid className='flex justify-between w-full items-center px-2'>
             <Typography fontWeight={600} fontSize={16}>{data.getData.totalText} Rupees Only</Typography>
             <Typography>Total</Typography>
         </Grid>
         <Grid  sx={{width:190, borderLeft:'1px solid ', padding:3 }}>
         <Typography fontWeight={600} fontSize={16} textAlign='right'>{parseFloat(data.getData.TotalData.totalAmount).toFixed(2)}</Typography>
         </Grid>
    </Grid> 
    
 
   
    {/* <Grid >
     <Typography align='right' sx={{fontWeight:600, paddingBlock:1,paddingRight:3,paddingBlockEnd:2}}>This is computer generated Invoice</Typography>
    </Grid> */}
 </Grid>
   }
</div>
  )
}

export default memo(ProductPdf)